import React from 'react'
import { useInView } from 'react-intersection-observer'

export default function Video (props) {
  const [slideUpRef, isInView] = useInView({ triggerOnce: true })
  const { poster, url } = props
  return (
    <div
      ref={slideUpRef}
      className={`row scholarship-video animation ${
        isInView ? 'slide-up' : ''
      } `}
    >
      <video width="1920" height="1080" poster={poster} controls playsinline>
        <source src={url} type="video/mp4"></source>
      </video>
    </div>
  )
}

//styling is in scholarships.scss
